/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../kubb/client";
import type { Client, RequestConfig, ResponseErrorConfig, ResponseConfig } from "../../../kubb/client";
import type { GetLeadByExternalIdConditionReportSchemaQueryResponse, GetLeadByExternalIdConditionReportSchemaPathParams, GetLeadByExternalIdConditionReportSchema401, GetLeadByExternalIdConditionReportSchema403, GetLeadByExternalIdConditionReportSchema404, GetLeadByExternalIdConditionReportSchema503 } from "../models/GetLeadByExternalIdConditionReportSchema";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLeadByExternalIdConditionReportSchemaQueryKey = ({ externalId }: { externalId: GetLeadByExternalIdConditionReportSchemaPathParams["externalId"] }) => [{ url: '/api/v1/contact/leads/by-external-id/:externalId/condition-report', params: {externalId:externalId} }] as const

export type GetLeadByExternalIdConditionReportSchemaQueryKey = ReturnType<typeof getLeadByExternalIdConditionReportSchemaQueryKey>

/**
 * @description Returns the condition report config with the driver's answers attached to each question. Use this to render a filled-out report without needing to join config and answers client-side. Looks up by the Lease End external deal ID instead of UUID.
 * @summary Get condition report with driver answers (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId/condition-report}
 */
export async function getLeadByExternalIdConditionReportSchema({ externalId }: { externalId: GetLeadByExternalIdConditionReportSchemaPathParams["externalId"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLeadByExternalIdConditionReportSchemaQueryResponse, ResponseErrorConfig<GetLeadByExternalIdConditionReportSchema401 | GetLeadByExternalIdConditionReportSchema403 | GetLeadByExternalIdConditionReportSchema404 | GetLeadByExternalIdConditionReportSchema503>, unknown>({ method : "GET", url : `/api/v1/contact/leads/by-external-id/${externalId}/condition-report`, ... requestConfig })
  return res
}

export function getLeadByExternalIdConditionReportSchemaQueryOptions({ externalId }: { externalId: GetLeadByExternalIdConditionReportSchemaPathParams["externalId"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLeadByExternalIdConditionReportSchemaQueryKey({ externalId })
        return queryOptions<ResponseConfig<GetLeadByExternalIdConditionReportSchemaQueryResponse>, ResponseErrorConfig<GetLeadByExternalIdConditionReportSchema401 | GetLeadByExternalIdConditionReportSchema403 | GetLeadByExternalIdConditionReportSchema404 | GetLeadByExternalIdConditionReportSchema503>, ResponseConfig<GetLeadByExternalIdConditionReportSchemaQueryResponse>, typeof queryKey>({
         enabled: !!(externalId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLeadByExternalIdConditionReportSchema({ externalId: externalId }, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns the condition report config with the driver's answers attached to each question. Use this to render a filled-out report without needing to join config and answers client-side. Looks up by the Lease End external deal ID instead of UUID.
 * @summary Get condition report with driver answers (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId/condition-report}
 */
export function useGetLeadByExternalIdConditionReportSchema<TData = ResponseConfig<GetLeadByExternalIdConditionReportSchemaQueryResponse>, TQueryData = ResponseConfig<GetLeadByExternalIdConditionReportSchemaQueryResponse>, TQueryKey extends QueryKey = GetLeadByExternalIdConditionReportSchemaQueryKey>({ externalId }: { externalId: GetLeadByExternalIdConditionReportSchemaPathParams["externalId"] }, options: 
{
  query?: Partial<QueryObserverOptions<ResponseConfig<GetLeadByExternalIdConditionReportSchemaQueryResponse>, ResponseErrorConfig<GetLeadByExternalIdConditionReportSchema401 | GetLeadByExternalIdConditionReportSchema403 | GetLeadByExternalIdConditionReportSchema404 | GetLeadByExternalIdConditionReportSchema503>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLeadByExternalIdConditionReportSchemaQueryKey({ externalId })
         

         const query = useQuery({
          ...getLeadByExternalIdConditionReportSchemaQueryOptions({ externalId }, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLeadByExternalIdConditionReportSchema401 | GetLeadByExternalIdConditionReportSchema403 | GetLeadByExternalIdConditionReportSchema404 | GetLeadByExternalIdConditionReportSchema503>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}